import {PreferredPaymentTypeEnum} from '@/services/api-clients';

export function driverPreferredPaymentTypeIconFilter(type: PreferredPaymentTypeEnum) {
  switch (type) {
    case PreferredPaymentTypeEnum.Daily: return 'mdi-calendar';
    case PreferredPaymentTypeEnum.Weekly: return 'mdi-calendar-week';
    case PreferredPaymentTypeEnum.OnDemand: return 'mdi-calendar-cursor';
  }
}
